import { BillShock } from '@boltenergy-be/shared'
import dayjs from 'dayjs'

/**
 * Check the settlement color based on the settlement amount and current instalment amount
 * @param {number} settlementAmount
 * @returns {"text-default" | "text-warning" | "text-positive"}
 */
export const getSettlementColor = (settlementAmount?: number): 'text-default' | 'text-warning' | 'text-positive' => {
  // If not enough information, return default color
  if (typeof settlementAmount !== 'number') {
    return 'text-default'
  }

  return settlementAmount > 0 ? 'text-warning' : 'text-positive'
}

/**
 * Check if today is within the period to show the bill shock card based on settlement period.
 * @param {Pick<BillShock["settlement"], "startDate" | "endDate"> | undefined} settlement
 * @returns {boolean}
 */
export const checkIsWithinVisibleBillShockPeriod = (
  settlement: Pick<BillShock['settlement'], 'startDate' | 'endDate'> | undefined
): boolean => {
  if (!settlement || !settlement?.startDate || !settlement?.endDate) {
    return false
  }

  const { startDate, endDate } = settlement
  const today = dayjs()
  const differenceWithStartDate = dayjs().diff(dayjs(dayjs(startDate)), 'months')
  const differenceWithEndDate = dayjs(endDate).diff(today, 'months')

  return differenceWithEndDate >= 3 && differenceWithEndDate <= 9 && differenceWithStartDate > 2
}

/**
 * Check if the bill shock amount is more than 1.5 times the instalment
 * @param {number | undefined} billShockAmount
 * @param {number | undefined} currentInstalmentAmount
 * @returns {boolean}
 */
export const checkIsBillShock = (billShockAmount?: number, currentInstalmentAmount?: number): false | 'positive' | 'negative' => {
  if (!billShockAmount || !currentInstalmentAmount) {
    return false
  }

  if (billShockAmount > currentInstalmentAmount * 1.5) {
    return 'positive'
  }

  if (billShockAmount < currentInstalmentAmount * -3) {
    return 'negative'
  }

  return false
}
